import React from 'react';

const TagsManagerImpressionsController = ({
  createImpressionTag,
  currentOrgId,
  onSuccess = () => {},
  createResult,
  ...props
}) => {
  const advertisers = [
    { value: 'LIQUIDM', appId: 'LiquidM', label: 'LiquidM' },
    { value: 'NEXXEN', appId: 'NEXXEN', label: 'Nexxen' },
    { value: 'BKO', appId: 'BKO', label: 'BKO' },
  ];

  const onSubmit = async (values) => {
    const { name, dsp } = values;

    await createImpressionTag({
      variables: {
        name,
        dsp,
        orgId: currentOrgId,
      },
    });

    onSuccess(createResult);
  };

  return React.cloneElement(props.children, {
    ...props.children.props,
    advertisers,
    onSubmit,
  });
};

export default TagsManagerImpressionsController;
